<script lang="ts" generics="T extends XataFormComponent">
  import { scrollToElement } from "@/Util/utils";

  import type { AchievabilityStatus } from "./modules/ProgramAchievability";

  import { ProgramAchievabilityStatusIcon } from "./ProgramElements";


    import { StickyButtonBannerHeader, XataLogo } from "@/Common";
    import { type ComponentProps, createEventDispatcher } from "svelte"
    import { programTypeDescription, programTypeTitle, type ProgramType, type XataFormComponent } from "@/Common/constants";

    const dispatch = createEventDispatcher()
    let achievability: AchievabilityStatus
    let achievabilityId: string

    export let formComponent: T
    export let plan: ComponentProps<InstanceType<T>>["plan"]
    export let programType: ProgramType.Challenge | ProgramType.BaseBuildPeak | ProgramType.Continuous
</script>

<StickyButtonBannerHeader class="max-w-[1800px] w-full">

    <div class="flex justify-center items-center gap-5 overflow-visible px-4 pb-4 pt-3 md:px-8 md:pb-8 md:pt-6" slot="header">
        <XataLogo class="w-24 h-24 text-xerteal-50" type="animated"/>
        <div class="flex flex-col">
            <span class="font-black text-2xl md:text-4xl text-white">{programTypeTitle[programType]}</span>
            <span class="text-base text-xerteal-100 max-w-xl">{programTypeDescription[programType]}</span>
        </div>   
    </div>

    <div class="flex flex-row gap-2 justify-end bg-white rounded-b p-2 md:px-5 md:py-4 shadow-md shadow-black/10 border-t-4 border-xerteal-400/10 border-solid border-b-0 border-x-0" slot="sticky">
        <button class="btn-xfai border-none bg-transparent hover:bg-xerteal-50 text-xerteal-700 gap-3 text-sm" on:click={() => scrollToElement(achievabilityId, -30)}>
            Achievability <i class="fa-question fa-regular text-xs -ml-2"/> <ProgramAchievabilityStatusIcon status={achievability} showCheck/>
        </button>

        <button class="btn-xfai border-none text-white bg-[--color-xert-teal] hover:bg-[--color-xert-blue] gap-2" on:click={() => dispatch('save')}>
            <span class="hidden md:block">Save</span>
            <i class="md:hidden fa-light fa-save" />
        </button>
    </div>

    <div class="flex flex-col gap-4" slot="body">
        <svelte:component this={formComponent} class="bg-white shadow-md shadow-black/10 px-5 pt-5 md:px-8 md:pt-8 pb-4 rounded" {plan} bind:achievabilityId bind:achievability/>
    </div>
</StickyButtonBannerHeader>